import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { APPCONFIG } from './config';
import { DatosGeneralesSAE } from './datos-generales-SAE';
import { LayoutService } from './layout/layout.service';

// 3rd
import 'styles/material2-theme.scss';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
import * as moment from 'moment';
import 'moment/locale/es';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [LayoutService],
})
export class AppComponent implements OnInit {
  public AppConfig: any;
  public datosGeneralesSAE: any;
  constructor(private router: Router) { 

    moment.locale('es');
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.datosGeneralesSAE = DatosGeneralesSAE;

    // Scroll to top on route change
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts